import { useUserConfig } from '../context/UserConfigContext';

export function useUserSetPreferences(): {
  showSaveSetButton: boolean;
  showUploadSetButton: boolean;
} {
  const { options } = useUserConfig();

  return {
    showSaveSetButton: options.showSaveSetButton,
    showUploadSetButton: options.showUploadSetButton,
  };
}
